import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZButton = _resolveComponent("VZButton")!
  const _component_VZRating = _resolveComponent("VZRating")!
  const _component_VZFile = _resolveComponent("VZFile")!
  const _component_VZAttachements = _resolveComponent("VZAttachements")!
  const _component_VZInput = _resolveComponent("VZInput")!
  const _component_VZPassword = _resolveComponent("VZPassword")!
  const _component_VZList = _resolveComponent("VZList")!
  const _component_VZCheckbox = _resolveComponent("VZCheckbox")!
  const _component_VZRadioButton = _resolveComponent("VZRadioButton")!
  const _component_VZParagraph = _resolveComponent("VZParagraph")!
  const _component_VZSwitchButton = _resolveComponent("VZSwitchButton")!
  const _component_VZLabel = _resolveComponent("VZLabel")!
  const _component_VZTextArea = _resolveComponent("VZTextArea")!
  const _component_VZDivider = _resolveComponent("VZDivider")!
  const _component_VZImage = _resolveComponent("VZImage")!
  const _component_VZDate = _resolveComponent("VZDate")!
  const _component_VZSignature = _resolveComponent("VZSignature")!
  const _component_VZTimer = _resolveComponent("VZTimer")!
  const _component_VZCamera = _resolveComponent("VZCamera")!
  const _component_VZLKLookup = _resolveComponent("VZLKLookup")!
  const _component_QrCodeValidate = _resolveComponent("QrCodeValidate")!
  const _component_QrCode = _resolveComponent("QrCode")!
  const _component_BarCode = _resolveComponent("BarCode")!
  const _component_BarCodeValidate = _resolveComponent("BarCodeValidate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.component.component === 'BUTTON')
      ? (_openBlock(), _createBlock(_component_VZButton, _mergeProps({ key: 0 }, _ctx.computedAttrs, {
          name: _ctx.component.name,
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'RATING')
      ? (_openBlock(), _createBlock(_component_VZRating, _mergeProps({ key: 1 }, _ctx.computedAttrs, {
          name: _ctx.component.name,
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'FILE')
      ? (_openBlock(), _createBlock(_component_VZFile, _mergeProps({ key: 2 }, _ctx.computedAttrs, {
          name: _ctx.component.name,
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('drop', $event))),
          onCustomEvent: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('customEvent', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'ATTACHEMENTS')
      ? (_openBlock(), _createBlock(_component_VZAttachements, _mergeProps({ key: 3 }, _ctx.computedAttrs, {
          name: _ctx.component.name,
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'TEXT_FIELD')
      ? (_openBlock(), _createBlock(_component_VZInput, _mergeProps({ key: 4 }, _ctx.computedAttrs, {
          name: _ctx.component.name,
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'HIDDEN')
      ? (_openBlock(), _createBlock(_component_VZInput, _mergeProps({ key: 5 }, _ctx.computedAttrs, {
          name: _ctx.component.name,
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[31] || (_cache[31] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[33] || (_cache[33] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[34] || (_cache[34] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[35] || (_cache[35] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[36] || (_cache[36] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'PASSWORD_FIELD')
      ? (_openBlock(), _createBlock(_component_VZPassword, _mergeProps({ key: 6 }, _ctx.computedAttrs, {
          name: _ctx.component.name,
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[37] || (_cache[37] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[38] || (_cache[38] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[39] || (_cache[39] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[40] || (_cache[40] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[41] || (_cache[41] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[42] || (_cache[42] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'LIST')
      ? (_openBlock(), _createBlock(_component_VZList, _mergeProps({
          key: 7,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[43] || (_cache[43] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[44] || (_cache[44] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[45] || (_cache[45] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[46] || (_cache[46] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[47] || (_cache[47] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[48] || (_cache[48] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'CHECK_BOX')
      ? (_openBlock(), _createBlock(_component_VZCheckbox, _mergeProps({ key: 8 }, _ctx.computedAttrs, {
          name: _ctx.component.name,
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[49] || (_cache[49] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[50] || (_cache[50] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[51] || (_cache[51] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[52] || (_cache[52] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[53] || (_cache[53] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[54] || (_cache[54] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'RADIO_BUTTON')
      ? (_openBlock(), _createBlock(_component_VZRadioButton, _mergeProps({
          key: 9,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[55] || (_cache[55] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[56] || (_cache[56] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[57] || (_cache[57] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[58] || (_cache[58] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[59] || (_cache[59] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[60] || (_cache[60] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'PARAGRAPH')
      ? (_openBlock(), _createBlock(_component_VZParagraph, _mergeProps({
          key: 10,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[61] || (_cache[61] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[62] || (_cache[62] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[63] || (_cache[63] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[64] || (_cache[64] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[65] || (_cache[65] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[66] || (_cache[66] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'SWITCH_BUTTON')
      ? (_openBlock(), _createBlock(_component_VZSwitchButton, _mergeProps({
          key: 11,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[67] || (_cache[67] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[68] || (_cache[68] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[69] || (_cache[69] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[70] || (_cache[70] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[71] || (_cache[71] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[72] || (_cache[72] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'LABEL')
      ? (_openBlock(), _createBlock(_component_VZLabel, _mergeProps({
          key: 12,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[73] || (_cache[73] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[74] || (_cache[74] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[75] || (_cache[75] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[76] || (_cache[76] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[77] || (_cache[77] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[78] || (_cache[78] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'TEXT_AREA')
      ? (_openBlock(), _createBlock(_component_VZTextArea, _mergeProps({ key: 13 }, _ctx.computedAttrs, {
          name: _ctx.component.name,
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[79] || (_cache[79] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[80] || (_cache[80] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[81] || (_cache[81] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[82] || (_cache[82] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[83] || (_cache[83] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[84] || (_cache[84] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'DIVIDER')
      ? (_openBlock(), _createBlock(_component_VZDivider, _mergeProps({
          key: 14,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[85] || (_cache[85] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[86] || (_cache[86] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[87] || (_cache[87] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[88] || (_cache[88] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[89] || (_cache[89] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[90] || (_cache[90] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'IMAGE')
      ? (_openBlock(), _createBlock(_component_VZImage, _mergeProps({
          key: 15,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[91] || (_cache[91] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[92] || (_cache[92] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[93] || (_cache[93] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[94] || (_cache[94] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[95] || (_cache[95] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[96] || (_cache[96] = ($event: any) => (_ctx.$emit('drop', $event))),
          onCustomEvent: _cache[97] || (_cache[97] = ($event: any) => (_ctx.$emit('customEvent', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'DATE')
      ? (_openBlock(), _createBlock(_component_VZDate, _mergeProps({
          key: 16,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[98] || (_cache[98] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[99] || (_cache[99] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[100] || (_cache[100] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[101] || (_cache[101] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[102] || (_cache[102] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[103] || (_cache[103] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'SIGNATURE')
      ? (_openBlock(), _createBlock(_component_VZSignature, _mergeProps({
          key: 17,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[104] || (_cache[104] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[105] || (_cache[105] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[106] || (_cache[106] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[107] || (_cache[107] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[108] || (_cache[108] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[109] || (_cache[109] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'TIMER')
      ? (_openBlock(), _createBlock(_component_VZTimer, _mergeProps({
          key: 18,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[110] || (_cache[110] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[111] || (_cache[111] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[112] || (_cache[112] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[113] || (_cache[113] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[114] || (_cache[114] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[115] || (_cache[115] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'CAMERA')
      ? (_openBlock(), _createBlock(_component_VZCamera, _mergeProps({
          key: 19,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[116] || (_cache[116] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[117] || (_cache[117] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[118] || (_cache[118] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[119] || (_cache[119] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[120] || (_cache[120] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[121] || (_cache[121] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'LOOKUP')
      ? (_openBlock(), _createBlock(_component_VZLKLookup, _mergeProps({
          key: 20,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[122] || (_cache[122] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[123] || (_cache[123] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[124] || (_cache[124] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[125] || (_cache[125] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[126] || (_cache[126] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[127] || (_cache[127] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'QR_VALIDATOR')
      ? (_openBlock(), _createBlock(_component_QrCodeValidate, _mergeProps({
          key: 21,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[128] || (_cache[128] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[129] || (_cache[129] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[130] || (_cache[130] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[131] || (_cache[131] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[132] || (_cache[132] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[133] || (_cache[133] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'QR_CODE')
      ? (_openBlock(), _createBlock(_component_QrCode, _mergeProps({
          key: 22,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[134] || (_cache[134] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[135] || (_cache[135] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[136] || (_cache[136] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[137] || (_cache[137] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[138] || (_cache[138] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[139] || (_cache[139] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'BAR_CODE')
      ? (_openBlock(), _createBlock(_component_BarCode, _mergeProps({
          key: 23,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[140] || (_cache[140] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[141] || (_cache[141] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[142] || (_cache[142] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[143] || (_cache[143] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[144] || (_cache[144] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[145] || (_cache[145] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true),
    (_ctx.component.component === 'BAR_VALIDATOR')
      ? (_openBlock(), _createBlock(_component_BarCodeValidate, _mergeProps({
          key: 24,
          name: _ctx.component.name
        }, _ctx.computedAttrs, {
          class: `${
      _ctx.component?.attrs?.id === _ctx.selectControl ? 'selectedControl' : ''
    }`,
          draggable: _ctx.isDraggable,
          isPreview: _ctx.isPreview,
          onDragstart: _cache[146] || (_cache[146] = ($event: any) => (_ctx.$emit('dragstart', $event))),
          onDragover: _cache[147] || (_cache[147] = ($event: any) => (_ctx.$emit('dragover', $event))),
          onDragenter: _cache[148] || (_cache[148] = ($event: any) => (_ctx.$emit('dragenter', $event))),
          onDragleave: _cache[149] || (_cache[149] = ($event: any) => (_ctx.$emit('dragleave', $event))),
          onDragend: _cache[150] || (_cache[150] = ($event: any) => (_ctx.$emit('dragend', $event))),
          onDrop: _cache[151] || (_cache[151] = ($event: any) => (_ctx.$emit('drop', $event)))
        }), null, 16, ["name", "class", "draggable", "isPreview"]))
      : _createCommentVNode("", true)
  ], 64))
}